<template>
  <PSkeleton
    class="s-button-skeleton"
    :class="{
      's-button-skeleton--fluid': fluid,
      's-button-skeleton--rounded': rounded,
    }"
    :height="height ?? defaultHeight"
    :width="width ?? defaultWidth"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

import PSkeleton from "@/atoms/PSkeleton.vue";

const props = withDefaults(
  defineProps<{
    fluid?: boolean;
    height?: string;
    rounded?: boolean;
    size?: "inline" | "lg" | "md" | "sm";
    width?: string;
  }>(),
  { size: "md" },
);

const defaultHeight = computed(
  () =>
    ({
      lg: "3.5rem",
      md: "3rem",
      sm: "2.5rem",
      inline: "1rem",
    })[props.size],
);

const defaultWidth = computed(() => {
  if (props.fluid) {
    return "100%";
  }
  return {
    lg: "8rem",
    md: "7rem",
    sm: "6rem",
    inline: "5rem",
  }[props.size];
});
</script>

<style lang="postcss">
.s-button-skeleton {
  @apply rounded-md;

  &--rounded {
    @apply rounded-full;
  }

  &--fluid {
    @apply w-full;
  }
}
</style>
